export default {
  id: 'employees',
  title: 'Employees',
  category: 'Admin',
  summary: 'Create and manage employee records, compensation, leave, benefits, and related settings.',
  overview: 'Employee records drive timesheet access, leave balances, payroll mapping, and profitability views. Detail pages are organized into tabs for different administrative concerns.',
  howItWorks: [
    'Creating an employee establishes their login identity and organizational attributes.',
    'Active/inactive status controls whether they can continue working in the system.',
    'Compensation and benefits data support payroll and cost analysis.',
    'Leave configuration feeds the employee Leave page and timesheet leave charging.',
    'Integration actions (such as Paylocity sync) keep external systems aligned when enabled.'
  ],
  actions: [
    {
      name: 'Create employee',
      description: 'Starts the employee create wizard to add a new person to Timeclerk.'
    },
    {
      name: 'Toggle active status',
      description: 'Deactivating prevents normal use while retaining historical data.'
    },
    {
      name: 'Reset password',
      description: 'Forces a password reset flow for the employee when local auth is used.'
    },
    {
      name: 'Edit compensation / leave / benefits tabs',
      description: 'Updates the data used for payroll costing, leave accrual, and benefits administration.'
    },
    {
      name: 'Sync with Paylocity',
      description: 'When integrated, pushes or refreshes employee mapping data with Paylocity.'
    }
  ],
  tips: [
    'Set up charge code assignments and an approver before expecting clean timesheet submissions.',
    'Review profitability and compensation tabs when investigating cost or billing anomalies.'
  ],
  related: ['timesheet', 'review', 'payroll', 'paylocity']
};



// WEBPACK FOOTER //
// ./client/help/content/employees.js